/* Adding elements inside a shopify section on Home */
function addElement(elem, parentNode, content, elemAttr, elemAttrVal, elemClass){
    const createNewElem = document.createElement(elem);
    if(elemAttr && elemAttrVal){
      createNewElem.setAttribute(elemAttr, elemAttrVal);
    }
    if(elemClass){
      createNewElem.classList.add(elemClass);
    }
    createNewElem.textContent = content;
    parentNode.append(createNewElem);
}

const testmSec = document.querySelector("#shopify-section-template--26337798357306__testimonials .testimonials-section");
const testmSecHeader = document.querySelector('#shopify-section-template--26337798357306__testimonials .testimonials-section .section-header');
const teamsTestmSec = document.querySelector("#shopify-section-template--26527554109754__testimonials_DKtcJt .testimonials-section");
const teamsTestmSecHeader = document.querySelector('#shopify-section-template--26527554109754__testimonials_DKtcJt .testimonials-section .section-header');
const OCTestmSec = document.querySelector("#shopify-section-template--26570092839226__testimonials_jYLtEm .testimonials-section");
const OCTestmSecHeader = document.querySelector('#shopify-section-template--26570092839226__testimonials_jYLtEm .testimonials-section .section-header');

if(testmSecHeader){
    addElement('h3', testmSecHeader, 'Celebrating those who care for all of us.');
    addElement('p', testmSecHeader, 'Everything we make is designed to support the people who support everyone else. These are real testimonials from healthcare professionals who not only wear SCRUPS, but have helped test and build them with us.');
}

if(testmSec){
  addElement('a', testmSec, 'Share Yours', 'href', 'https://scrups.com/pages/voices-of-our-uplifters', 'btn');
}

if(teamsTestmSec){
  addElement('a', teamsTestmSec, 'START A TEAM ORDER', 'href', '#', 'btn');
}

if(teamsTestmSecHeader){
  addElement('h3', teamsTestmSecHeader, 'Hear how SCRUPS empowers, uplifts, and unites teams across diverse healthcare industries, from hospitals and clinics to education and beyond.');
}

if(OCTestmSecHeader){
    addElement('h3', OCTestmSecHeader, 'Celebrating those who care for all of us.');
    addElement('p', OCTestmSecHeader, 'Everything we make is designed to support the people who support everyone else. These are real stories from healthcare professionals who not only wear SCRUPS, but have helped test and build them with us.');
}

if(OCTestmSec){
  addElement('a', OCTestmSec, 'Share Yours', 'href', 'https://scrups.com/pages/voices-of-our-uplifters', 'btn');
}

/* Wrapping elements inside a new div for About Us page section */
const parentEls = document.querySelectorAll("#shopify-section-template--26527454560570__text_columns_ccLVkM .text-column__grid .text-center");

parentEls.forEach((el) => {
  const el_1 = el.querySelector("h3");
  const el_2 = el.querySelector(".rte-setting");

  if (!el_1 || !el_2) return;

  const newWrapperEl = document.createElement("div");
  newWrapperEl.classList.add("qual-content-wrapper");
  newWrapperEl.appendChild(el_1);
  newWrapperEl.appendChild(el_2);

  el.appendChild(newWrapperEl);
});

/* Adding element in a section on our Community page */
function addingTxtInSec(targetElemSelector, newElemTag, newElemClass, newElemTxt){
  const targetElem = document.querySelector(targetElemSelector);
  const newElem = document.createElement(newElemTag);
  newElem.classList.add(newElemClass);
  newElem.textContent = newElemTxt;
  if(targetElem){
    targetElem.before(newElem);
  }
}
addingTxtInSec("#shopify-section-template--26570092839226__blocks_rTNKNA .custom-multi-sec .custom-multi-sec__bottom-bg-sec .ai-bottom-button-asmjpouh4uvbbu0qzoaigenblockdec65bcqn7vyt", "p", "bfu-above-btn-txt", 'Welcome to the movement. Welcome to the Uplifters.');
addingTxtInSec("#shopify-section-template--26806795141434__blocks_zritE8 .custom-multi-sec .custom-multi-sec__bottom-bg-sec .ai-bottom-button-ay0pzevdkbffqyllgbaigenblockdec65bckcbpgh", "p", "bfu-above-btn-txt", 'Welcome to the movement. Welcome to the Uplifters.');

/* Recommended Products Main Title change */
let rpTitleElem = document.querySelector(".template-product #shopify-section-template--26337798717754__177162099842bb51b5 .index-section .mrp-title");
if(rpTitleElem){
  rpTitleElem.innerHTML = "WEAR IT WITH";
}

/* Single Product Page Popup */
const popupElem = document.querySelector('.size-guide-popup-wrapper');
if(popupElem){
  popupElem.classList.add('hide-popup');
  document.addEventListener('DOMContentLoaded', function(){
  const productPage = document.querySelector(".template-product");
  if(productPage){
    const popupOpenTrigger = document.querySelector('[data-trigger="open-popup"]');
    const popupCloseTrigger = document.querySelector('[data-trigger="close-popup"]');
    if(popupElem && popupOpenTrigger && popupCloseTrigger){
      popupOpenTrigger.addEventListener('click', function(e){
        e.preventDefault();
        popupElem.classList.remove('hide-popup');
      });
      popupCloseTrigger.addEventListener('click', function(e){
        e.preventDefault();
        popupElem.classList.add('hide-popup');
      });
    }
  }
  });
}

/* Adding class into CTAs on Uplifters Page */
const upFaqCtaElem = document.querySelector("#shopify-section-template--27069082534202__faq_gCdkcB .index-section--faq a");
const upAppCtaElem = document.querySelector("#shopify-section-template--27069082534202__rich_text_kJCkrc .text-center .theme-block:last-child .enlarge-text p > a");
if(upFaqCtaElem){
  upFaqCtaElem.classList.add("btn"); 
}
if(upAppCtaElem){
  upAppCtaElem.classList.add("btn");
}

const cartShoppingBtn = document.querySelector(".template-cart #shopify-section-template--26337798259002__main .section-header a");
if(cartShoppingBtn){
  cartShoppingBtn.setAttribute("href", "https://scrups.com/collections");
}

/* Hide "Sold Out" btn from Single Product page */
function toggleSoldOutButton() {
  const paymentBtnsWrapper = document.querySelector(".template-product .payment-buttons");
  const soldOutBtn = document.querySelector('.template-product .payment-buttons .add-to-cart [data-default-text="Add to cart"]');
  if (!paymentBtnsWrapper || !soldOutBtn) return;

  let notifyMsg = paymentBtnsWrapper.querySelector(".sold-out-message");

  if (soldOutBtn.textContent.trim() === "Sold Out") {
    soldOutBtn.parentElement.style.display = "none";

    if (!notifyMsg) {
      notifyMsg = document.createElement("span");
      notifyMsg.className = "sold-out-message";
      notifyMsg.textContent = "Coming soon. Sign up to get a notification when item becomes available.";
      paymentBtnsWrapper.insertBefore(notifyMsg, paymentBtnsWrapper.firstChild);
    }
  } else {
    soldOutBtn.parentElement.style.display = "";
    if (notifyMsg) {
      notifyMsg.remove();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  toggleSoldOutButton();
  const paymentBtnsWrapper = document.querySelector(".template-product .payment-buttons");
  if (!paymentBtnsWrapper) return;

  const observer = new MutationObserver(() => {
    toggleSoldOutButton();
  });

  observer.observe(paymentBtnsWrapper, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

/* Homepage Collection Section CTA */
const homeCollectionCTA = document.querySelector("#collection1-template--26337798357306__featured-collection-switcher .btn");
homeCollectionCTA.setAttribute("href", "https://scrups.com/collections/women");